import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import { API, defaultLimitPagination, get } from "../../config";
import { debounce } from "lodash";

const RTAProjectSelectForBankReconciliation = (props) => {
  const [regionName, setRegionName] = useState(null);

  useEffect(() => {
    setRegionName(props.regionName);
  }, [props.regionName]);

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    const search = searchQuery?.length >= 3 ? searchQuery : "";
    // const formData = new FormData();
    // formData.append("builder_id", props?.builderId);
    // formData.append("builder_project_id", props?.builder_project_id);
    // formData.append("trust_type", 0);
    // formData.append("limit", defaultLimitPagination);
    // formData.append("page", page && !search ? page : 1);
    // formData.append("search", search ? search : "");

    const response = await get(
      `${API.GET_RTA_PROJECT_FOR_BANK_RECONCILIATION}?builder_project_id=${
        props?.builder_project_id
      }&trust_type=0&limit=${defaultLimitPagination}&page=${
        page && !search ? page : 1
      }&serach=${search ? search : ""}`
      // formData
    );
    const responseJSON = response?.data?.data?.data
      ? response?.data?.data?.data
      : [];

    const totalLength = loadedOptions?.length
      ? loadedOptions?.length + responseJSON?.length
      : responseJSON?.length;

    return {
      options: responseJSON,
      hasMore: totalLength < response?.data?.data?.total,
      additional: {
        page: search ? 2 : page + 1,
      },
    };
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceLoadOptions = useCallback(
    debounce((searchQuery, loadedOptions, { page }, callback) => {
      loadOptions(searchQuery, loadedOptions, { page }).then(callback);
    }, 600), // Adjust the debounce delay as needed
    []
  );

  const handleLoadOptions = useCallback(
    (searchQuery, loadedOptions, { page }) => {
      if (searchQuery) {
        return new Promise((resolve) => {
          debounceLoadOptions(searchQuery, loadedOptions, { page }, resolve);
        });
      } else {
        return loadOptions(searchQuery, loadedOptions, { page });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debounceLoadOptions]
  );

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  return (
    <AsyncPaginate
      key={JSON.stringify(regionName)}
      value={props.value || props.defaultValue}
      loadOptions={handleLoadOptions}
      getOptionValue={(option) => option?.id}
      getOptionLabel={(option) => option?.project_name}
      onChange={onChange}
      classNamePrefix={props?.className || "builder-select"}
      isSearchable={true}
      placeholder={props.placeholder}
      additional={{
        page: 1,
      }}
      isClearable={props.isClearable}
      isDisabled={props.disable}
    />
  );
};

RTAProjectSelectForBankReconciliation.propTypes = {
  regionName: PropTypes.any,
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default RTAProjectSelectForBankReconciliation;
